<template>
  <div class="edit-password-form">
    <el-form :model="form"
             :rules="rules"
             ref="form"
             class="form-password"
             :label-position="labelPosition">
      <el-form-item :label="$t('setting.setPassword.oldPassword')"
                    prop="oldPassword"
                    :label-width="formLabelWidth">
        <el-input v-model="form.oldPassword"
                  maxlength="16"
                  :type="oldPasswordStatus?'text':'password'"
                  :suffix-icon="oldPasswordStatus?'showPwd1':'disablePwd1'"
                  autocomplete="off">
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('setting.setPassword.newPassword')"
                    prop="newPassword"
                    :label-width="formLabelWidth">
        <el-input v-model="form.newPassword"
                  maxlength="16"
                  :type="newPasswordStatus?'text':'password'"
                  :suffix-icon="newPasswordStatus?'showPwd2':'disablePwd2'"
                  autocomplete="off">
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('setting.setPassword.confirmPassword')"
                    prop="confirmPassword"
                    :label-width="formLabelWidth">
        <el-input v-model="form.confirmPassword"
                  maxlength="16"
                  :type="confirmPasswordStatus?'text':'password'"
                  :suffix-icon="confirmPasswordStatus?'showPwd3':'disablePwd3'"
                  autocomplete="off">
        </el-input>
      </el-form-item>
    </el-form>
    <div slot="footer"
         class="dialog-footer">
      <el-button type="primary"
                 class="submit-button"
                 :loading="loading"
                 @click="submitForm('form')">
        {{$t('setting.setPassword.submit')}}
      </el-button>
    </div>
    <div slot="footer"
         class="dialog-footer">
      <el-button type="primary"
                 class="cancel-button"
                 :disabled="cancel"
                 @click="cancelHandle('form')">
        {{$t('setting.setPassword.cancel')}}
      </el-button>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    var checkOldPassword = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('setting.setPassword.oldPassword')))
      } else {
        callback()
      }
    }
    var validatePass = (rule, value, callback) => {
      let patrn = /^[A-Za-z0-9]{6,15}$/
      if (value === '') {
        callback(new Error(this.$t('setting.setPassword.newPassword')))
      } else if (value.length > 15 || value.length < 6) {
        callback(new Error(this.$t('setting.setPassword.checkPassWrongLen')))
      } else if (!patrn.exec(value)) {
        callback(new Error(this.$t('setting.setPassword.checkTradePassword')))
      } else {
        if (this.form.newPassword !== '') {
          this.$refs.form.validateField('confirmPassword')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('setting.setPassword.confirmPassword')))
      } else if (value !== this.form.newPassword) {
        callback(new Error(this.$t('setting.setPassword.passwordInconsistent')))
      } else {
        callback()
      }
    }
    return {
      form: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      formLabelWidth: '120px',
      labelPosition: 'top',
      loading: false,
      cancel: false,
      oldPasswordStatus: false,
      newPasswordStatus: false,
      confirmPasswordStatus: false,
      rules: {
        oldPassword: [
          { validator: checkOldPassword, trigger: 'change' }
        ],
        newPassword: [
          { validator: validatePass, trigger: 'change' }
        ],
        confirmPassword: [
          { validator: validatePass2, trigger: 'change' }
        ]
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      document.querySelectorAll('.disablePwd1').forEach(item => {
        item.addEventListener('click', this.showPwd1)
      })
      document.querySelectorAll('.disablePwd2').forEach(item => {
        item.addEventListener('click', this.showPwd2)
      })
      document.querySelectorAll('.disablePwd3').forEach(item => {
        item.addEventListener('click', this.showPwd3)
      })
    })
  },
  methods: {
    notClickable () {
      this.loading = true
      this.cancel = true
    },
    clickable () {
      this.loading = false
      this.cancel = false
    },
    submitForm (formName) {
      this.notClickable()
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$emit('submitHandle', this.form)
        } else {
          this.clickable()
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    cancelHandle () {
      this.$emit('cancelHandle')
    },
    showPwd1 () {
      this.oldPasswordStatus = !this.oldPasswordStatus
    },
    showPwd2 () {
      this.newPasswordStatus = !this.newPasswordStatus
    },
    showPwd3 () {
      this.confirmPasswordStatus = !this.confirmPasswordStatus
    }
  }
}
</script>
<style lang="scss">
.edit-password-form {
  .submit-button,
  .cancel-button {
    width: 100%;
    height: 100%;
    margin: auto;
    line-height: 20px;
    color: black !important;
    border: 1px solid rgba(255, 255, 255, 0);
  }
  .cancel-button {
    background: white !important;
    border: 1px solid black !important;
  }
  .dialog-footer {
    width: 100%;
    height: 3rem;
    margin: 1rem auto;
  }
  .dialog-footer:first-child {
    margin-top: -1rem;
  }
  .el-form-item__label {
    font-family: Muli-Regular !important;
    font-size: 11px !important;
    color: #7d7d7d !important;
    letter-spacing: 0.13px !important;
  }
  .el-input__inner {
    border: 1px solid #e0e0e0 !important;
    border-radius: 5px !important;
    font-family: Muli-Bold !important;
    font-size: 14px !important;
    color: #24282d !important;
    letter-spacing: 0 !important;
  }
  .showPwd1,
  .showPwd2,
  .showPwd3,
  .disablePwd1,
  .disablePwd2,
  .disablePwd3 {
    margin-top: 12px;
    width: 20px;
    height: 20px;
    display: inline-block;
    background-position: center;
    background-repeat: no-repeat;
    background-size: 20px;
    margin-right: 0px !important;
    cursor: pointer;
  }
  .showPwd1,
  .showPwd2,
  .showPwd3 {
    background: url("../../../../assets/images/disabledPwd.svg") no-repeat;
  }
  .disablePwd1,
  .disablePwd2,
  .disablePwd3 {
    background: url("../../../../assets/images/showPwd.svg") no-repeat;
  }
}
</style>
